import { Button,  Divider,  SwipeableDrawer } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";

import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useTranslation } from "react-i18next";

import { config } from "../../common/config";
import {  navRoutes } from "../../common/routes";

// const theme = createTheme();

const useStyles = makeStyles(() => ({
  wrapper: {},
  paper: {
    backgroundColor: `#fff!important`,
  },
  content: {
    minWidth: "250px",
    marginTop: "2rem",
  },

  link: {
    color: "#666",
    "&:hover": {
      backgroundColor: "#E8E8EA",
      // fontWeight:'bold',
      color: "#000",
    },
    marginBottom: "0.5rem",
    display: "flex",
    alignItems: "center",
    padding: "1rem",
  },
  activeLink: {
    backgroundColor: "#E8E8EA",
    // fontWeight:'bold',
    color: "#000",
  },
  navItem: {
    paddingLeft: "1rem",
    display: "flex",
    alignItems: "center",
  },
  navItemIcon: {
    marginRight: "0.4rem",
  },
  navItemTitle: {},

  //////////
  langWrapper: {
    display: "flex",
    justifyContent: "space-evenly",
    borderTop: "2px solid #ccc",
    paddingTop: "1rem",
    marginTop: "2rem",
  },
}));

const Sidebar = (props) => {
  const classes = useStyles();
  const { t ,i18n} = useTranslation();
  const changeLang = (lan)=>{
    i18n.changeLanguage(lan);
    props.handleClose()
  }
  return (
    <div className={classes.wrapper}>
      <React.Fragment>
        <SwipeableDrawer
          anchor={"left"}
          open={props.open}
          onClose={props.handleClose}
          onOpen={props.handleOpen}
          classes={{ paper: classes.paper }}
        >
          <div className={classes.content}>
          <div style={{paddingLeft:'1rem',color:'#666'}}>
            <div className={classes.navItem}>
                <AccountCircle className={classes.navItemIcon} /> 
                {(props.defaultValues?.name || props.defaultValues?.phone)?<span className={classes.navItemTitle}>{props.defaultValues?.name}</span>:
                <span className={classes.navItemTitle}>Гость</span>}

              </div>
          
           </div>
           <Divider sx={{margin:'1rem 0'}}/>
            {navRoutes.map((r) => {
              return (
                <r.component
                  to={r.path}
                  className={classes.link}
                  key={r.path}
                  onClick={r.action}
                  activeClassName={classes.activeLink}
                >
                  <div className={classes.navItem} onClick={()=>{props.handleClose()}}>
                    <r.icon className={classes.navItemIcon} />
                    <span className={classes.navItemTitle}>
                      {t(r.title)}
                    </span>
                  </div>
                </r.component>
              );
            })}
            
            
          </div>
          <div className={classes.langWrapper}>
            {props.languagesData.map((l,index)=>{
              // debugger
              return(
                <Button key={'btn' + index} onClick={i18n.language===l.value?()=>{}:()=>{localStorage.setItem(config.localStorageNames.lang,l.value);changeLang(l.value)}} variant={i18n.language===l.value?'contained':'outlined'} >
                    <span className='tt-upper'>{l.value}</span>
                </Button>
              )
            })}
          </div>
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
};

export default Sidebar;
